import { render, staticRenderFns } from "./MatchTimeLine.vue?vue&type=template&id=181d149c&scoped=true"
import script from "./MatchTimeLine.vue?vue&type=script&lang=js"
export * from "./MatchTimeLine.vue?vue&type=script&lang=js"
import style0 from "./MatchTimeLine.vue?vue&type=style&index=0&id=181d149c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181d149c",
  null
  
)

export default component.exports